module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 96
// module chunks = 35783957827783 70144966829960 114276838955818 263791100135453